const dev = {
  apiUrl: window.env.DEV_API_URL,
  veriffMockUrl: window.env.VERIFF_MOCK_API_URL
};

const prod = {
  apiUrl: window.env.PROD_API_URL,
};

const config = process.env.NODE_ENV === "production" ? prod : dev;

export default {
  // Add common config values here
  ...config,
};
